import React from 'react';

export default function OrbitMusicPrivacy() {
  return (
    <div className="p-8 text-white max-w-4xl mx-auto space-y-8 glass-card mt-24 leading-relaxed">

      <h1 className="text-4xl font-bold mb-6 border-b border-gray-700 pb-4">OrbitMusic Privacy Policy</h1>

      <p className="text-gray-300">Last updated: April 27, 2026</p>

      <p className="text-lg">
        OrbitMusic ("the App") is committed to protecting your privacy. This policy explains how we handle your information.
      </p>

      <section>
        <h2 className="text-2xl font-semibold mb-3 text-blue-400">1. No Personal Data Collection</h2>
        <p className="text-gray-300">
          OrbitMusic is a <strong>local music player</strong>. We do not collect, store, or transmit any personal identification, usage analytics, or crash reports to external servers. All app operations happen locally on your device.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-3 text-blue-400">2. Permissions Usage</h2>
        <p className="text-gray-300 mb-4">
          To provide a premium music experience, OrbitMusic requests the following permissions:
        </p>
        
        <div className="space-y-4">
          <div className="bg-white/5 p-4 rounded-lg border-l-4 border-blue-400">
            <h3 className="text-xl font-semibold text-white mb-2">Audio Recording (RECORD_AUDIO)</h3>
            <p className="text-gray-300">
              This permission is used <strong>exclusively</strong> for the real-time audio visualizer. The App captures audio frequency data to generate UI animations. <strong>OrbitMusic DOES NOT record, save, or upload any audio.</strong> Processing is done entirely in volatile memory.
            </p>
          </div>

          <div className="bg-white/5 p-4 rounded-lg border-l-4 border-blue-400">
            <h3 className="text-xl font-semibold text-white mb-2">Media Storage (READ_MEDIA_AUDIO)</h3>
            <p className="text-gray-300">
              Used to scan and play your local music files and display your album artwork. No media is ever transmitted outside your device.
            </p>
          </div>
        </div>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-3 text-blue-400">3. Data Security & On-Device Processing</h2>
        <p className="text-gray-300">
          OrbitMusic is designed with a "Privacy by Design" philosophy. Since the App does not have a server component and does not upload data, your music library and settings remain strictly on your physical device. All indexing and search operations occur locally.
        </p>
      </section>

      <section className="bg-white/5 p-6 rounded-xl border border-blue-500/30">
        <h2 className="text-2xl font-semibold mb-3 text-yellow-400">4. Core Principles</h2>
        <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
          <li><strong>No Audio is Recorded:</strong> We only process live frequency data.</li>
          <li><strong>No Audio is Uploaded:</strong> All processing is done in volatile memory.</li>
          <li><strong>No Data is Sold:</strong> We do not sell or share any user information.</li>
          <li><strong>Transparency:</strong> We are clear about why we need permissions.</li>
        </ul>
      </section>

      <section className>
        <h2 className="text-2xl font-semibold mb-3 text-blue-400">5. Data Sharing</h2>
        <p className="text-gray-300">
          We do not share, sell, or trade your data with third parties. Since no data is collected or uploaded, your information never leaves your physical device.
        </p>
      </section>

      <section className="mt-8 pt-6 border-t border-gray-700">
        <h2 className="text-xl font-semibold mb-2">Contact Us</h2>
        <p className="text-gray-400">
          If you have questions about this Privacy Policy, please contact the development team at: <br />
          <strong className="text-white">localnewsappin@gmail.com</strong>
        </p>
      </section>

    </div>
  );
}
